<template>
    <!-- <h1>Hello App!</h1>
  <p>
    <strong>Current route path:</strong> {{ $route.fullPath }}
  </p> -->
  <!-- <nav>
    <RouterLink to="/">Go to Home</RouterLink>
    <RouterLink to="/about">Go to About</RouterLink>
    <RouterLink to="/dungeonquestidle/privacypolicy">Privacy Policy</RouterLink>
  </nav> -->
  <main>
    <RouterView />
  </main>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
html, body, #app {
  background-color: #252525;
  color: #ffffff;       /* เพื่อให้ข้อความอ่านง่ายขึ้น หากต้องการ */
  margin: 0;            /* ลบ margin เริ่มต้นของ body */
  padding: 0;           /* ลบ padding เริ่มต้นของ body */
  min-height: 100vh;    /* ให้ body หรือ #app สูงเต็มจอ */
  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
